<template>
	<div class="flex w-full items-center gap-2">
		<div class="relative">
			<BrokerAvatar
				:border="false"
				:show-company-avatar="false"
				:avatar-fallback-class="cn(backgroundVariants({ variant: bgVariant }))"
				class="size-10 cursor-pointer text-lg text-white"
				:is-navbar="true"
				:initials="initials"
				:broker-src="null"
			/>
			<span
				v-if="!user?.hasCompletedRegistration"
				class="absolute right-1 top-0 size-2 rounded-full bg-tertiary"
			/>
		</div>
		<div class="flex flex-col">
			<span
				class="text-base font-normal leading-6"
				:class="portalHeaderNavLoggedInfosName({ variant })"
			>
				{{ firstAndLastName.join(' ') }}
			</span>
			<span
				v-if="user?.email"
				class="text-xs leading-[18px] text-white-dark-4"
				:class="portalHeaderNavLoggedInfosEmail({ variant })"
			>
				{{ user?.email }}
			</span>
		</div>
		<slot name="icon" />
	</div>
</template>
<script setup lang="ts">
import type {
	BackgroundVariantProps,
	PortalHeaderNavLoggedInfosEmailVariantProps
} from '.';

import { cn } from '@/utils';
import { capitalizeFirstLetter } from '~/core/service/googleMaps/utils';
import { USER_SYMBOL } from '~~/utils/symbols';

import {
	backgroundVariants,
	portalHeaderNavLoggedInfosEmail,
	portalHeaderNavLoggedInfosName
} from '.';

const user = inject(USER_SYMBOL);

defineProps<{
	variant: PortalHeaderNavLoggedInfosEmailVariantProps['variant'];
	bgVariant: BackgroundVariantProps['variant'];
}>();

const firstAndLastName = computed<string[]>(() => {
	const names = user?.value?.name?.trim().split(' ') || [];

	if (!names.length) return names;

	return (
		[...new Set([names[0], names.at(-1)])].map(name =>
			capitalizeFirstLetter(name || '')
		) || []
	);
});

const initials = computed(() => {
	return firstAndLastName.value
		.map(name => name?.[0])
		.join('')
		.toUpperCase();
});
</script>
